export const AG_GRID_THEME = 'ag-theme-balham'
export const LEVEL_SEPARATOR = '▬'
export const SUMMARY_ROW_COUNT_SEPARATOR = ' / '
export const ICON_SIZE = 21
// Use this for getting column by GridApi#getColumn.
export const AUTO_COLUMN_ID = 'ag-Grid-AutoColumn'
